import { apiClient } from './client';
import { SiteUpdate, SiteUpdatePage, SiteUpdatePayload } from '../types/siteUpdate';

export async function fetchSiteUpdateCapability(): Promise<{ canManage: boolean }> {
  const { data } = await apiClient.get<{ canManage: boolean }>('/site-updates/capability');
  return data;
}

export async function fetchSiteUpdates(params?: {
  keyword?: string;
  page?: number;
  size?: number;
}): Promise<SiteUpdatePage> {
  const { data } = await apiClient.get<SiteUpdatePage>('/site-updates', {
    params: {
      ...(params?.keyword?.trim() ? { q: params.keyword.trim() } : {}),
      page: params?.page ?? 0,
      size: params?.size ?? 20,
    },
  });
  return data;
}

export async function fetchSiteUpdate(updateId: number): Promise<SiteUpdate> {
  const { data } = await apiClient.get<SiteUpdate>(`/site-updates/${updateId}`);
  return data;
}

export async function createSiteUpdate(payload: SiteUpdatePayload): Promise<SiteUpdate> {
  const { data } = await apiClient.post<SiteUpdate>('/site-updates', payload);
  return data;
}

export async function updateSiteUpdate(
  updateId: number,
  payload: Partial<SiteUpdatePayload>
): Promise<SiteUpdate> {
  const { data } = await apiClient.patch<SiteUpdate>(`/site-updates/${updateId}`, payload);
  return data;
}

export async function deleteSiteUpdate(updateId: number): Promise<void> {
  await apiClient.delete(`/site-updates/${updateId}`);
}
